import {Locale} from '../RootProvider/LocaleContext';

const getCurrencyFromLocale = (locale: Locale): string => {
  switch (locale) {
    case Locale.nl:
      return '€';
    case Locale.uk:
    default:
      return '£';
  }
};

export default getCurrencyFromLocale;
